import React, { useEffect, useState } from 'react';
import { ConnectedStateModalView } from './ConnectedStateModal.view';

export interface ConnectedStateModalProps {
  title: string;
  children?: React.ReactNode;
  isOpen?: boolean;
  actionButton?: React.ReactNode;
  onCloseAction?: () => void;
}

const ConnectedStateModal = ({
  title,
  isOpen = false,
  actionButton,
  children,
  onCloseAction
}: ConnectedStateModalProps) => {
  const [isOpenModal, setOpenModal] = useState(false);
  useEffect(() => {
    isOpen && setOpenModal(true);
  }, [isOpen]);

  const onClose = () => {
    setOpenModal(false);
    onCloseAction && onCloseAction();
  };
  return (
    <>
      {isOpenModal && (
        <ConnectedStateModalView
          title={title}
          onClose={onClose}
          actionButton={actionButton}
        >
          {children}
        </ConnectedStateModalView>
      )}
    </>
  );
};

export default ConnectedStateModal;
